const OtherFAQs = () => {
  return (
    <div className="section-footer section-spacing-40 no-padding-bottom center">
      <a href="/frequently-asked-questions" className="button subcta">
        See Other FAQs
      </a>
    </div>
  );
};

export default OtherFAQs;
